import React from 'react';
import { hasPermission, PERMISSION_NAME } from '../utils/permissions';
import { Permission, GenericObject, SearchEntity } from 'v2/models';
import { connect } from 'react-redux';
import CustomChat from './CustomChat';
import Chat from 'v2/pages/SearchDetails/Chat';
import { searchViewPath } from 'v2/utils/searchViewUtils';

interface ChatSelectorProps {
  permissions: {
    permissions: { [key: string]: Permission };
    loaded: boolean;
  };
}
interface ChatSelectorOwnProps {
  search?: SearchEntity;
  className?: string;
  comingFromPath?: string;
}

type ChatSelectorAllProps = ChatSelectorProps & ChatSelectorOwnProps;

const ChatSelector = ({
  permissions,
  search,
  className,
  comingFromPath,
}: ChatSelectorAllProps) => {
  const isMonitor = hasPermission(permissions.permissions, [
    PERMISSION_NAME.MONITOR_SEARCHES_MASTER_ORG,
    PERMISSION_NAME.MONITOR_SEARCHES_ORG,
  ]);

  if (
    isMonitor &&
    search &&
    comingFromPath &&
    comingFromPath.includes(searchViewPath.allSearches)
  ) {
    return <CustomChat search={search} />;
  } else {
    return <Chat search={search} className={className} />;
  }
};

const mapStateToProps = (state: GenericObject): ChatSelectorProps => {
  return {
    permissions: state.permissions,
  };
};

export default connect<ChatSelectorProps>(mapStateToProps)(ChatSelector);
